/**
 * Dashboard API服务
 */
import apiClient from './client'

export interface RealtimeData {
  onlineDoctors: number
  todayConsultations: number
  satisfactionRate: number
  avgResponseTime: string
  aiAccuracy: number
  lastUpdated: string
}

export interface Statistics {
  users: {
    total: number
    patients: number
    doctors: number
    pharmacists: number
    technicians: number
    admins: number
    legal: number
  }
  consultations: {
    total: number
    completed: number
    inProgress: number
    cancelled: number
    avgDuration: number
  }
  departments: {
    total: number
    active: number
    specialties: Array<{
      name: string
      consultations: number
    }>
  }
  performance: {
    avgResponseTime: number
    systemUptime: number
    errorRate: number
    apiResponseTime: number
  }
}

export interface PopularService {
  id: number
  name: string
  icon: string
  description: string
  usageCount: number
  rating: number
}

export interface HealthNews {
  id: number
  title: string
  summary: string
  publishDate: string
  category: string
  readCount: number
  author: string
}

export interface Announcement {
  id: number
  title: string
  content: string
  type: string
  priority: string
  publishDate: string
  isActive: boolean
}

/**
 * 获取实时数据
 */
export const getRealtimeData = async (): Promise<RealtimeData> => {
  const response = await apiClient.get('/v1/dashboard/realtime')
  return response as unknown as RealtimeData
}

/**
 * 获取系统统计
 */
export const getStatistics = async (timeRange: string = '24h'): Promise<Statistics> => {
  const response = await apiClient.get('/v1/dashboard/statistics', {
    params: { timeRange }
  })
  return (response as unknown as { data: Statistics }).data || response as unknown as Statistics
}

/**
 * 获取热门服务
 */
export const getPopularServices = async (): Promise<PopularService[]> => {
  const response = await apiClient.get('/v1/dashboard/popular-services')
  return (response as unknown as { data: PopularService[] }).data || response as unknown as PopularService[]
}

/**
 * 获取健康资讯
 */
export const getHealthNews = async (limit: number = 10): Promise<HealthNews[]> => {
  const response = await apiClient.get('/v1/dashboard/health-news', {
    params: { limit }
  })
  return (response as unknown as { data: HealthNews[] }).data || response as unknown as HealthNews[]
}

/**
 * 获取系统公告
 */
export const getAnnouncements = async (): Promise<Announcement[]> => {
  const response = await apiClient.get('/v1/dashboard/announcements')
  return (response as unknown as { data: Announcement[] }).data || response as unknown as Announcement[]
}

